var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelBluesky14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M4.262 3.314C5.37 4.146 6.562 5.833 7 6.738c.437-.905 1.63-2.592 2.738-3.424.8-.6 2.095-1.065 2.095.413 0 .295-.17 2.48-.269 2.834-.345 1.233-1.602 1.548-2.72 1.358 1.955.332 2.452 1.434 1.378 2.536-2.04 2.094-2.932-.525-3.16-1.196C7.02 9.136 7 9.08 7 9.128c0-.05-.02.008-.062.131-.229.671-1.12 3.29-3.16 1.196C2.704 9.353 3.2 8.251 5.156 7.92c-1.119.19-2.376-.125-2.72-1.358-.1-.354-.27-2.539-.27-2.834 0-1.478 1.296-1.014 2.096-.413"
}))));
export default SvgChannelBluesky14;